import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-datepicker.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const DatePickerIcon = createSvgIcon(<Icon />, 'DatePickerIcon');
